import {
  MatButtonModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule
} from '@angular/material';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { WebAccessPopupComponent } from './web-access-popup.component';

@NgModule({
  declarations: [WebAccessPopupComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
  ], exports: [WebAccessPopupComponent, MatDialogModule],
  entryComponents: [WebAccessPopupComponent]
})
export class WebAccessPopupModule { }
